import { Appointment, ContentSection, ContentParentLink, Picture } from '@/components'
import { StyledContent, StyledTitle } from '@/components/styles'
import addSoftHyphenation from '@/lib/addSoftHyphenation'
import { useTranslation } from "react-i18next";

export default function ArticlePage(props) {
  const { title, image, content: htmlContent } = props
  const { t } = useTranslation("global");

  return (
    <StyledContent withLine>
      <StyledContent.Container>
        <StyledContent.Columns>
          <ContentParentLink type="promotions">{t('promotions.title')}</ContentParentLink>

          <StyledContent.ColumnSide>
            <StyledContent.Side>
              <StyledTitle mb="medium" as="h1">
                {addSoftHyphenation(title, 15)}
              </StyledTitle>

              <StyledContent.Button>
                <Appointment />
              </StyledContent.Button>
            </StyledContent.Side>
          </StyledContent.ColumnSide>
          <StyledContent.ColumnMain>
            <ContentSection noTitle>
              {Object.keys(image).length > 0 && (
                <StyledContent.Img>
                  <Picture {...image} />
                </StyledContent.Img>
              )}
              {htmlContent && (
                <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} />
              )}
            </ContentSection>
          </StyledContent.ColumnMain>
        </StyledContent.Columns>
      </StyledContent.Container>
    </StyledContent>
  )
}
